import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { FichaDaObraService } from 'src/app/ficha-da-obra/service/ficha-da-obra.service';
import { environment } from 'src/environments/environment';
import { FiltroSelectBuscaComponent } from '../../filtro-select-busca/filtro-select-busca.component';
import Swal from 'sweetalert2';
import { FiltroSelectOption } from '../../filtro-select/filtro-select.component';

@Component({
  selector: 'app-editar-relato',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatIconModule,
    FiltroSelectBuscaComponent,
  ],
  templateUrl: './editar-relato.component.html',
  styleUrls: ['./editar-relato.component.scss'],
})
export class EditarRelatoComponent implements OnInit {
  @Input() relato: any;
  @Output() close = new EventEmitter<void>();
  @Output() relatoEditado = new EventEmitter<void>();

  @Output() loading = new EventEmitter<boolean>();
  @Input() idObra: number | null = null;
  @Input() moduloId: number | null = null;

  BASE_IMG_URL: string = environment.BASE_IMG_URL;

  descricao: string = '';
  titulo: string = '';
  responsavel: any[] = [];
  selectedResponsaveis: any[] = [];
  enviarEmail = false;

  private _fichaDaObraService = inject(FichaDaObraService);

  constructor() {}

  ngOnInit() {
    this.descricao = this.relato?.descricao || '';
    this.titulo = this.relato?.titulo || '';
    this.enviarEmail = this.relato?.enviarEmail || false;
    this.selectedResponsaveis = (this.relato?.responsaveis || []).map(
      (r: any) => r.id
    );
    this.popularResponsavelObra();
  }

  get contatoOptions(): FiltroSelectOption[] {
    return this.responsavel.map((r) => ({ value: r.id, label: r.name }));
  }

  popularResponsavelObra(): void {
    this._fichaDaObraService.popularResponsavelObra().subscribe(
      (response) => {
        this.responsavel = (response.data || []).sort((a: any, b: any) =>
          (a.name || '').localeCompare(b.name || '', 'pt-BR')
        );
      },
      (error) => {}
    );
  }

  editarRelato() {
    this.loading.emit(true);
    if (!this.relato?.raw || !this.idObra) {
      console.error(
        'Erro: Propriedade raw ou ID da obra ausentes no relato:',
        this.relato
      );
      return;
    }

    const body: any = {
      title: this.titulo,
      text: this.descricao,
      textTypeID:
        this.enviarEmail && this.selectedResponsaveis.length > 0 ? 2 : 1,
      sendEmailContactIDs: this.enviarEmail
        ? this.selectedResponsaveis.length > 0
          ? this.selectedResponsaveis.join(',')
          : '0'
        : null,
      isEdited: true,
      reportID: this.relato.raw.reportID,
    };

    this._fichaDaObraService.novoRelato(this.idObra, body).subscribe({
      next: () => {
        this.relato.raw.source = 'editar-relato';
        this.loading.emit(false);
        Swal.fire('Sucesso!', 'Relato editado com sucesso!', 'success').then(
          () => {
            this.relatoEditado.emit();
            this.close.emit();
          }
        );
      },
      error: (err) => {
        console.error('Erro ao editar relato:', err);
        this.loading.emit(false);
      },
    });
  }

  criarRelato() {
    if (!this.relato?.raw || !this.idObra) {
      console.error(
        'Erro: Propriedade raw ou ID da obra ausentes no relato:',
        this.relato
      );
      return;
    }

    const sendEmailContactIDs =
      this.enviarEmail && this.selectedResponsaveis.length > 0
        ? this.selectedResponsaveis.map((id: any) => Number(id))
        : null;

    const body: any = {
      title: this.titulo,
      text: this.descricao,
      sendEmailContactIDs,
    };

    this._fichaDaObraService.novoRelato(this.idObra, body).subscribe({
      next: () => {
        this.relato.raw.source = 'criar-relato';
        this.relatoEditado.emit();
      },
      error: (err) => {
        console.error('Erro ao criar relato:', err);
      },
    });
  }

  fechar() {
    this.close.emit();
  }

  clear() {
    this.descricao = '';
    this.titulo = '';
    this.enviarEmail = false;
    this.selectedResponsaveis = [];
  }
}
